export default "__VITE_ASSET__BRbfj6Wc__"